import React, { ReactElement } from "react";

import { CanvasObjectGraphic } from "../../types/canvas-object";
import { CanvasElement, CanvasElementProps } from "../composer/canvas-element";

import { useGraphic } from "./use-graphic";

export type CanvasGraphicElementProps = Omit<
  CanvasElementProps,
  "canvasObject" | "canvasObjectSize" | "imageUrl"
> & {
  graphic: CanvasObjectGraphic;

  objectChanged: (data: Partial<Omit<CanvasObjectGraphic, "kind">>) => void;
};

export default function CanvasGraphicElement(
  props: CanvasGraphicElementProps,
): ReactElement {
  const { graphic, ...canvasElementProps } = props;

  const graphicResult = useGraphic(graphic.graphicId);

  const graphicData = graphicResult.data?.graphic;
  if (!graphicData) {
    return <></>;
  }

  const imageUrl = graphicData.previewUrl;

  return (
    <>
      <CanvasElement
        canvasObject={graphic}
        canvasObjectSize={{
          width: graphicData.asset.width,
          height: graphicData.asset.height,
        }}
        imageUrl={imageUrl}
        {...canvasElementProps}
      />
    </>
  );
}
